import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { dataFromSnapshot } from "../firestore/firestoreService";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "../redux/data/async/asyncReducer";

// interface IUserFirestoreDoc {
//   query?: string;
//   docId: string;
//   data?: (data: any) => void;
//   deps?: any[];
// }
export const userFirestoreDoc: any = ({
  query,
  data,
  deps,
  shouldExecute = true,
  local,
  localSetLoader,
  onData,
}: any) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!shouldExecute) return;
    if (!query()) return;
    local
      ? localSetLoader && localSetLoader(true)
      : dispatch(asyncActionStart());
    const unsubscribe = query().onSnapshot(
      (snapshot: any) => {
        const snapshotData = dataFromSnapshot(snapshot);
        onData?.(snapshotData);
        local ? data(snapshotData) : dispatch(data(snapshotData));
        local
          ? localSetLoader && localSetLoader(false)
          : dispatch(asyncActionFinish());
      },
      (error: any) => dispatch(asyncActionError(error)),
    );
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  }, deps);
};
